import { forwardRef, InputHTMLAttributes, useState } from 'react'

// Input de senha com "olhozinho" pra mostrar/ocultar o que foi digitado
// (conferir se digitou certo) - usado em toda tela com campo de senha
// (login, redefinir senha, acesso). Aceita as mesmas props de um <input>
// normal (value/onChange/className/etc) e usa forwardRef porque as
// telas de login usam react-hook-form (register() manda um ref junto -
// sem forwardRef o React avisa "Function components cannot be given
// refs" e o valor do campo nao e capturado). iconeClassName permite
// ajustar a cor do icone quando o campo esta sobre um fundo escuro
// proprio (paginas publicas com hero escuro fixo).
type Props = InputHTMLAttributes<HTMLInputElement> & { iconeClassName?: string }

const CampoSenha = forwardRef<HTMLInputElement, Props>(function CampoSenha(
  { className = '', iconeClassName = 'text-compumaq-textoSuave hover:text-compumaq-texto', ...props },
  ref
) {
  const [visivel, setVisivel] = useState(false)

  return (
    <div className="relative">
      <input {...props} ref={ref} type={visivel ? 'text' : 'password'} className={`${className} pr-10`} />
      <button
        type="button"
        onClick={() => setVisivel((v) => !v)}
        tabIndex={-1}
        aria-label={visivel ? 'Ocultar senha' : 'Mostrar senha'}
        className={`absolute inset-y-0 right-0 flex items-center px-3 ${iconeClassName}`}
      >
        {visivel ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  )
})

export default CampoSenha
